import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { isAndroid, isIOS } from 'react-device-detect';
import { BroadcasterView } from '../components/broadcaster/BroadcasterView';
import { BroadcasterViewMobile } from '../components/broadcaster/BroadcasterViewMobile';
import { ViewerView } from '../components/viewer/ViewerView';
import { ViewerViewMobile } from '../components/viewer/ViewerViewMobile';
import { EmbeddedView } from '../components/views/EmbeddedView';
import { BroadcastStateService } from '../services/broadcaststate/BroadcastStateService';
import { RecordingService } from '../services/recording/RecordingService';
export function BroadcastPage({ embedded }) {
    const activeBroadcast = BroadcastStateService.getOutput().useRequiredActiveBroadcast();
    const recordingService = RecordingService.getNotificationInterface();
    useEffect(() => {
        return () => {
            recordingService.notifyStopRecording();
        };
    }, [recordingService.notifyStopRecording]);
    if (embedded) {
        return _jsx(EmbeddedView, {});
    }
    if (isIOS || isAndroid) {
        return activeBroadcast.myRole === 'broadcaster' ? (_jsx(BroadcasterViewMobile, {})) : (_jsx(ViewerViewMobile, {}));
    }
    return activeBroadcast.myRole === 'broadcaster' ? (_jsx(BroadcasterView, {})) : (_jsx(ViewerView, {}));
}
